import axios from 'axios';

export const api = axios.create({
  // baseURL: 'http://localhost:5003', // Local
  // baseURL: 'https://portalfroneri-dev.flexxone.com.br/Backend', // DEV
  // baseURL: 'https://portalfroneri-sit.flexxone.com.br/Backend', // SIT
  // baseURL: 'https://portalfroneri-uat.flexxone.com.br/Backend', // UAT
  baseURL: 'https://portalfroneri.flexxone.com.br/Backend', // PROD
});

// src/services